import logo from '../public/nextjs/static/assets/images/logo.svg'

interface Props {
  disableLink?: boolean
}
export default function Header({ disableLink = false }: Props) {
  return (
    <header className="Header">
      {disableLink ? (
        <div className="Header__logo" aria-label="OnDemandKorea">
          <img src={logo} alt="OnDemandkorea" />
        </div>
      ) : (
        <a className="Header__logo" href="/" aria-label="OnDemandKorea">
          <img src={logo} alt="OnDemandkorea" />
        </a>
      )}
    </header>
  )
}
